module.exports = __webpack_public_path__ + "static/media/logo.bb5a4c94.png";